import React, { useState } from "react";
import { Stack, TextField, IconButton } from "@mui/material";
import { Check } from "react-feather";

export function InlineEditCell({ initialValue, onSave, onCancel, placeholder, validate, prefix }) {
  const [value, setValue] = useState(initialValue);
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ width: "100%", overflow: "hidden" }}>
      {prefix}
      <TextField
        size="small" value={value}
        onChange={(e) => { const v = e.target.value; if (!validate || validate(v)) setValue(v); }}
        onKeyDown={(e) => { e.stopPropagation(); if (e.key === "Enter") onSave(value); if (e.key === "Escape") onCancel(); }}
        autoFocus
        sx={{ flex: 1, minWidth: 0, "& input": { fontSize: "0.75rem", py: 0.5, px: 1 } }}
        placeholder={placeholder}
      />
      <IconButton size="small" onClick={() => onSave(value)}><Check size={14} /></IconButton>
    </Stack>
  );
}
